import React from 'react'

import Review from 'site/client/components/review/Review/Review'
import Title from 'components/_new/typography/deprecated/Title/Title'

import messages from './messages'
import s from './Reviews.scss'


const CommonPageReviews = (props) => {
  const { list, brandName } = props

  return Boolean(list.length) && (
    <div className={s.reviewsList}>
      <Title message={messages.title} values={{ brandName }} align="center" uppercase html />
      {
        list.map((review) => (
          <Review
            key={review.id}
            review={review}
            withMicrodata
          />
        ))
      }
    </div>
  )
}

CommonPageReviews.defaultProps = {
  list: [],
}

export default CommonPageReviews
